// export DsfProjectConfig from "./projectConfig.js";
export const DsfProjectConfig = dsf.defineAsyncComponent("DsfProjectConfig", () => import(/*webpackChunkName:"platform_system_setting"*/ "./projectConfig.js"));

